export default "__VITE_ASSET__5e275205__"